import { html, nothing } from "lit";
import type { CodexConfigSource, JsonObject } from "../api/client";
import { i18n } from "../i18n";

export function configSourceLabel(source?: CodexConfigSource) {
  return i18n.t(source === "local" ? "codexConfigLocal" : "codexConfigCustom");
}

export function configSourceField(
  source: CodexConfigSource,
  change: (value: CodexConfigSource) => void,
) {
  return html`<label class="native-field">
      <span>${i18n.t("codexConfigSource")}</span>
      <select
        class="a2k-native-input"
        name="config_source"
        .value=${source}
        @change=${(event: Event) => change((event.target as HTMLSelectElement).value as CodexConfigSource)}
      >
        <option value="custom">${i18n.t("codexConfigCustom")}</option>
        <option value="local">${i18n.t("codexConfigLocal")}</option>
      </select>
    </label>
    ${source === "local" ? html`<p class="wide field-help-static">${i18n.t("codexConfigLocalHelp")}</p>` : nothing}`;
}

/** Local credentials stay server-side; empty overrides inherit its config. */
export function configPayload(
  source: CodexConfigSource,
  values: JsonObject,
  persistent = false,
): JsonObject {
  const result: JsonObject = { ...values, config_source: source };
  if (source !== "local") return result;
  for (const key of [
    "apikey",
    "base_url",
    "protocol",
    "provider_api_key",
    "provider_base_url",
  ])
    delete result[key];
  for (const key of ["model", "reasoning_effort", "effort"]) {
    if (result[key] !== "" && result[key] !== undefined && result[key] !== null)
      continue;
    if (persistent && (key === "model" || key === "effort")) result[key] = null;
    else delete result[key];
  }
  if (result.model !== "custom") delete result.custom_model;
  return result;
}
